import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { toggleModalWithTimer } from 'actions/appAction';
import { toggleChat } from 'actions/chatAction';

import { OnfidoService } from 'services/OnfidoService';

import { AF_RECIPIENT_ONFIDO_IN_REVIEW_PROMO_DONE_CLICKED } from 'constants/amplitude/AmplitudeEvents';
import { SCENARIO_ID } from 'constants/amplitude/AmplitudeParamName';
import { KYC_FAILED_SCREEN, KYC_VERIFYING_SCREEN, ONFIDO_SDK } from 'constants/ComponentNames';
import { LANDING_LINK } from 'constants/UrlConstants';

import { apiFetchData } from 'helpers/api';
import { addOnfido } from 'helpers/DOM';

import * as Sentry from '@sentry/react';
import amplitude from 'amplitude-js';
import { useExtra, usePageMessages } from 'hooks/selectors';
import { useThemeDetector } from 'hooks/theme';
import { OnfidoContainer } from 'pages-auth/kyc/OnfidoFramePage';

import { CommonPagePromo } from '../common/CommonPagePromo';
import { PromoDangerouslyHtml } from '../common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoInfoPage } from '../common/PromoInfoPage/PromoInfoPage';

const AntiFraudRecipientOnlyMotion = (props) => {
    const ANTIFRAUD_SCENARIO_ID = 500;

    const extra = useExtra();
    const [screen, setScreen] = useState(ONFIDO_SDK);

    const onfidoOutRef = useRef(null);
    const messages = usePageMessages();
    const paymentInfo = extra.paymentInfo;
    const { theme } = useThemeDetector();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (typeof window.Onfido === 'undefined') {
                addOnfido(() => {
                    initOnfido();
                });
            } else {
                initOnfido();
            }
        }
        return () => {
            onfidoOutRef.current?.tearDown();
        };
    }, []);

    const initOnfido = () => {
        let options = OnfidoService.getMotionFraudOption();

        onfidoOutRef.current = OnfidoService.init(window.Onfido, extra.onfidoAccessToken, options, onComplete, onError, theme);
    };

    const onComplete = () => {
        apiFetchData(`/antifraud/onfido/recipient/uploaded/document`, getRecipientFieldsForOnfido());

        props.toggleModalWithTimer(true, messages.submittedSpinner, () => {
            setScreen(KYC_VERIFYING_SCREEN);
        });
    };

    const onError = (data) => {
        Sentry.captureMessage('Recipient Onfido Frame error', {
            extra: {
                countryId: extra.paymentInfo?.recipientCountry,
                data: data,
            },
            level: 'error',
        });

        setScreen(KYC_FAILED_SCREEN);
    };

    const onClickBackIcon = () => {
        window.location.href = LANDING_LINK;
    };

    const getRecipientFieldsForOnfido = () => {
        return [
            {
                name: 'uuid',
                value: paymentInfo.uuid,
            },
            {
                name: 'currentScenarioId',
                value: paymentInfo.currentScenarioId,
            },
        ];
    };

    const openChat = (e) => {
        e.preventDefault();
        props.toggleChat(true);
    };

    const componentMap = {
        [ONFIDO_SDK]: (
            <CommonPagePromo backUrl={LANDING_LINK} onClickIcon={onClickBackIcon}>
                {' '}
                <OnfidoContainer id="onfido-mount" />{' '}
            </CommonPagePromo>
        ),
        [KYC_VERIFYING_SCREEN]: (
            <PromoInfoPage
                iconName="clock-thin"
                iconColor="purple"
                headerText={messages.verifyScreenTitle}
                secondaryText={<PromoDangerouslyHtml dangerouslyHtml={messages.verifyScreenText} />}
                primaryButtonCaption={messages.gotItButton}
                primaryButtonType="link"
                primaryButtonLink={LANDING_LINK}
                primaryButtonOnClick={() => {
                    amplitude.getInstance().logEvent(AF_RECIPIENT_ONFIDO_IN_REVIEW_PROMO_DONE_CLICKED, { [SCENARIO_ID]: ANTIFRAUD_SCENARIO_ID });
                }}
            />
        ),
        [KYC_FAILED_SCREEN]: (
            <CommonPagePromo>
                <PromoInfoPage
                    iconName={'cross-id-card-thin'}
                    iconColor="purple"
                    headerText={<PromoDangerouslyHtml dangerouslyHtml={messages.onfidoErrorTitle} />}
                    buttonRowCaption={messages.chatWithSupportText}
                    buttonRowOnClick={openChat}
                    buttonRowType="link"
                    primaryButtonCaption={messages.gotItButton}
                    primaryButtonType="link"
                    primaryButtonLink={LANDING_LINK}
                />
            </CommonPagePromo>
        ),
    };

    return <>{screen ? componentMap[screen] : null}</>;
};
export default connect(null, {
    toggleChat,
    toggleModalWithTimer,
})(AntiFraudRecipientOnlyMotion);
